import { render, staticRenderFns } from "./questionarios.vue?vue&type=template&id=31d4bf0e&scoped=true"
import script from "./questionarios.vue?vue&type=script&lang=js"
export * from "./questionarios.vue?vue&type=script&lang=js"
import style0 from "./questionarios.vue?vue&type=style&index=0&id=31d4bf0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4bf0e",
  null
  
)

export default component.exports